import Common from '../common/Common';
import notiFriends from '../notice/notiFriends';
import tmpl from './notiTemplate';
import api from './notiApi';
import { getJsonp } from '../service/fetchJsonp';
import { strBoolToBool } from '../common/util';
import { empty } from '../common/domUtil';
import { getNotiLangCode } from '../common/const';

const userDataLocale = getNotiLangCode();
const com = Common.instance;
const $dispatcher = document.createElement('div');

let isLoading = false;
let isFirst = true;
let pageTotal = 1;
let pageNum = 0;
let pageSize = 100;
let container = {};
let loadingBar;

function init() {
    const ul = document.createElement('ul');
    const notiList = document.querySelector('#notiList');
    const loading = document.querySelector('#notiList .loading');

    notiList?.appendChild(ul);
    container = document.querySelector('#notiList ul');
    if(loading) {
        loadingBar = loading;
    } else {
        notiList.insertAdjacentHTML('beforeend', tmpl.tmpLoading());
        loadingBar = document.querySelector('#notiList .loading');
    }
}

// 알림 확인 이벤트 등록
function addEventAlarmConfirm(item) {
    const wrapNotice = item?.querySelector('.wrapNotice');

    wrapNotice?.addEventListener('click', e => {
        const $target = e.currentTarget;
        const { notiid = null, isnew = false } = $target?.dataset;
        const isNewBool = strBoolToBool(isnew);
        
        if(isNewBool && notiid && api.confirm) {    
            getJsonp({
                url: api.confirm,
                params: {
                    notiID: notiid
                }
            });
        }
    });
}

//알림리스트 로딩-------------------------------------------------------------------------------------------
function notiListLoadStart() {
    if (isLoading) return;

    const { l10nData } = com || {};
    const apiData = window.notiDummyData || api;

    isLoading = true;
    loadingBar.innerHTML = l10nData.Notifications.Loading;
    loadingBar.style.display = 'block';
    pageNum++;

    getJsonp({
        url: apiData.list,
        params: {
            targetCategory: 'GNB_NOTI',
            pageSize: pageSize,
            pageNo: pageNum,
            language: userDataLocale,
            https: window.location.protocol === 'https:'
        }
    })
    .then(res => {
        const result = res?.result || {};
        isLoading = false;
        loadingBar.style.display = 'none';
        listLoadComplete(result);
        $dispatcher?.dispatchEvent(new CustomEvent('load-complete'));
    })
    .catch(err => {
        isLoading = false;
        loadingBar.style.display = 'none';
        container?.insertAdjacentHTML('beforeend', tmpl.tmpNoMsg(com.l10nData.Notifications.ErrorOccurred));
    });
}

function listLoadComplete(result = {}) {
    const { returnCode, notiResult } = result;
    const { notiList = [], totalCount = 0, serverMillisec } = notiResult || {};
    const numReturnCode = parseInt(returnCode, 10);

    if (numReturnCode === 0) {
        const numTotalCount = parseInt(totalCount, 10);
        if (numTotalCount <= 0) {
            pageTotal = 0;
            pageNum = 0;
            document.querySelector('.wrapNoticeBox')?.remove();
            container?.insertAdjacentHTML('beforeend', tmpl.tmpNoMsg(com.l10nData.Notifications.NoNewNotifications));
        } else {
            if (isFirst) {
                pageTotal = Math.floor(numTotalCount / pageSize) + 1;
                isFirst = false;
            }

            tmpl.setCurrentTime(serverMillisec);

            let newList;
            for (let i = 0, j = notiList?.length; i < j; i++) {
                newList = tmpl.tmpMsg(notiList[i]);
                addEventAlarmConfirm(newList); // 알림 확인 이벤트 등록
                container?.append(newList);
                imgError(newList, notiList[i]);
            }

            notiFriends.init(notiList);
        }
    } else {
        let msg = '';

        switch(numReturnCode) {
            case 401:
                msg = com.l10nData.Notifications.LoginRequired;
                break;
            case 999:
                msg = com.l10nData.Notifications.Maintenance;
                break;
            default:
                msg = com.l10nData.Notifications.ErrorOccurred;
        }
        
        container?.insertAdjacentHTML('beforeend', tmpl.tmpNoMsg(msg));
    }
}

function imgError(_cont, _obj) {
    const imgs = typeof _cont === 'string' ? document.querySelectorAll(_cont) : _cont?.querySelectorAll('.thumb img');
    if (!imgs || imgs.length === 0) return;

    imgs.forEach(img => {
        img.addEventListener('error', e => {
            const target = e.target;
            target?.setAttribute('src', _obj.onErrorUrl);
            target?.setAttribute('alt', '');
        }, { once: true });
    });
}

function listLoadError(_data) {
    setTimeout(function () {
        empty(document.querySelector('#notiList ul'));
        con.innerHTML = tmpl.tmpNoMsg(com.l10nData.Notifications.Maintenance);
    }, 100);
}

let isFirstInit = true;
window.gnbNtError = listLoadError;

window.cnbNotiApi = api;
window.ncNotice = {
    $dispatcher,
    start() {
        const noticeListUl = document.querySelectorAll('#notiList ul');

        if (isFirstInit || !noticeListUl.length) {
            init();
            isFirstInit = false;
        }
        isFirst = true;
        pageTotal = 0;
        pageNum = 0;
        while(container?.firstChild) {
            container.removeChild(container?.firstChild);
        }
        notiListLoadStart();
    },
};